import { CrossIcon, DocumentIcon, EyeIcon, Loading2, Plus } from 'assets/icons';
import UseModal from 'components/modal/useModal';
import useSlideOver from 'components/SlideOver/useSlideOver';
import { dateWordShort } from 'helper/helper';
import UseContext from 'hooks/useContext';
import useImportedTimeSheet from 'hooks/useImportedTimeSheet';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Tooltip from 'components/tooltips/Tooltips';
import ApiDatabase from 'server';
import Button from 'components/button';
import TableCell from './TableCell';
import TableRow from './TableRow';

const applyImportedFlags = (rows, importedFlags) =>
  importedFlags
    ? rows?.map((item) =>
        importedFlags[item._id] !== undefined
          ? { ...item, is_imported_bestt: importedFlags[item._id] }
          : item
      )
    : rows;

const Tbodyhours = ({ champsBody }) => {
  const { toggleSlideOver } = useSlideOver();
  const {
    setObjID,
    roleUser,
    setContent,
    updatedTimesheet,
    setUpdatedTimesheet,
    setMissionInitialPage,
  } = UseContext();
  const { toggle } = UseModal();
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('xsrfToken');
  const [selectedId, setSelectedId] = useState(null);
  // Flags published by an earlier toggle are applied from the first render:
  // applied by the effect below, they would change the row right after mount
  // and light it up as if it had just been updated.
  const [data, setData] = useState(() =>
    applyImportedFlags(champsBody, updatedTimesheet)
  );
  const [waitingStates, setWaitingStates] = useState({});

  const { toggleImported, timeSheetVerified } = useImportedTimeSheet();

  useEffect(() => {
    setData(champsBody);
  }, [champsBody]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    if (id) {
      setSelectedId(id);
    }
  }, [location]);

  const handleModal = (e, i, item) => {
    e.preventDefault();
    setObjID(i);
    setContent({
      title: item.title,
      idMission: item.id_mission_reel,
      nameCompany: item.name_commercial,
    });

    const currentUrl = window.location.pathname;
    const params = new URLSearchParams(window.location.search);
    params.set('id', i);
    window.history.replaceState({}, '', `${currentUrl}?${params.toString()}`);

    navigate(`../ficheHour/${i}`);
  };

  const handleModalConsult = (e, i, item) => {
    e.preventDefault();
    setObjID(i);
    setContent({
      title: item.title,
      idMission: item.id_mission_reel,
      nameCompany: item.name_commercial,
    });

    const currentUrl = window.location.pathname;
    const params = new URLSearchParams(window.location.search);
    params.set('id', i);
    window.history.replaceState({}, '', `${currentUrl}?${params.toString()}`);

    navigate(`../ficheHour/${i}`);
  };

  const openTempWorkerInfo = (id) => {
    setObjID(id);
    toggleSlideOver('get_temp_worker');
  };

  const openMissionInfo = (item) => {
    // Définir l'onglet initial à "Détail de mission" (page 3) quand on vient du relevé d'heures
    setMissionInitialPage(3);
    
    // Utiliser id_mission (ObjectId MongoDB) si disponible
    // id_mission est la référence ObjectId vers la mission dans le modèle timesheet
    if (item.id_mission) {
      setObjID(item.id_mission);
      toggleSlideOver('get_mission');
    } else if (item.id_mission_reel) {
      // Si on n'a que l'ID numérique, chercher la mission pour récupérer son ObjectId MongoDB
      ApiDatabase.searchMission(
        { token, search: item.id_mission_reel.toString(), optionSearch: 'id_mission' },
        (data) => {
          if (data.missions && data.missions.length > 0) {
            // Utiliser l'ID MongoDB de la mission trouvée (id_mission_real)
            const mission = data.missions.find(m => m.id_mission === parseInt(item.id_mission_reel) || m.id_mission?.toString() === item.id_mission_reel?.toString());
            if (mission && mission.id_mission_real) {
              setObjID(mission.id_mission_real);
              toggleSlideOver('get_mission');
            } else if (data.missions[0].id_mission_real) {
              setObjID(data.missions[0].id_mission_real);
              toggleSlideOver('get_mission');
            }
          }
        },
        (err) => {
          console.error('Error fetching mission:', err);
        }
      );
    }
  };

  const openCompanyInfo = (companyId) => {
    // Si c'est déjà un ID MongoDB (ObjectId), l'utiliser directement
    if (companyId && companyId.length === 24 && /^[0-9a-fA-F]{24}$/.test(companyId)) {
      setObjID(companyId);
      toggleSlideOver('get_company');
    } else if (companyId) {
      // Sinon, chercher l'entreprise par son ID BeSTT ou nom
      ApiDatabase.getCompanies(
        { token, search: companyId.toString(), optionSearch: 'id_company' },
        (data) => {
          if (data.companies && data.companies.length > 0) {
            setObjID(data.companies[0]._id);
            toggleSlideOver('get_company');
          } else {
            // Si pas trouvé avec id_company, essayer avec id_bestt
            ApiDatabase.getCompanies(
              { token, search: companyId.toString() },
              (data) => {
                if (data.companies && data.companies.length > 0) {
                  // Chercher celle qui correspond à l'ID BeSTT
                  const company = data.companies.find(c => c.id_bestt === parseInt(companyId) || c.id_bestt === companyId);
                  if (company) {
                    setObjID(company._id);
                    toggleSlideOver('get_company');
                  }
                }
              },
              (err) => {
                console.error('Error fetching company:', err);
              }
            );
          }
        },
        (err) => {
          console.error('Error fetching company:', err);
        }
      );
    }
  };

  // Remplacement de la fonction importBestt par handleToggleImported
  const handleToggleImported = (isImported, idTimeSheet) => {
    setWaitingStates((prev) => ({ ...prev, [idTimeSheet]: true }));
    toggleImported(isImported, idTimeSheet, (imported) => {
      setData((prevData) =>
        prevData.map((item) =>
          item._id === idTimeSheet
            ? { ...item, is_imported_bestt: imported }
            : item
        )
      );
      // `data` is a copy of rows the parent page keeps across navigations, and
      // this component is unmounted every time the sheet detail opens. Without
      // publishing the flag, the row goes back to its pre-toggle state on return.
      setUpdatedTimesheet((prev) =>
        prev[idTimeSheet] === imported ? prev : { ...prev, [idTimeSheet]: imported }
      );
      setWaitingStates((prev) => ({ ...prev, [idTimeSheet]: false }));
    });
  };

  useEffect(() => {
    if (updatedTimesheet) {
      setData((prevData) => applyImportedFlags(prevData, updatedTimesheet));
    }
  }, [updatedTimesheet]);

  return (
    <>
      {data?.map((item, key) => {
        const handleRowClick = () => {
          if (item.validated === 1 || item.validated === 2) {
            handleModal({ preventDefault: () => {} }, item._id, item);
          } else if (item.validated !== 0) {
            handleModalConsult({ preventDefault: () => {} }, item._id, item);
          }
        };

        return (
          <TableRow
            key={key}
            itemId={item._id}
            selectedId={selectedId}
            onClick={handleRowClick}
            flashSignature={[item.is_imported_bestt, item.validated]}
            className="tr-time-sheet motion-safe:animate-fadeUp"
            // Capped so the bottom of a long page does not wait for the top.
            style={{ animationDelay: `${Math.min(key, 9) * 30}ms` }}
          >
            <TableCell position="first" isSelected={selectedId === item._id}>
              {item.id_time_sheet}
            </TableCell>
            <TableCell 
              clickable
              onClick={(e) => {
                e.stopPropagation();
                // Essayer d'abord avec id_company (MongoDB ID), sinon id_bestt_company (BeSTT ID)
                const companyId = item.id_company || item.id_bestt_company || item.company?._id;
                if (companyId) {
                  openCompanyInfo(companyId);
                }
              }}
              tooltipText="Voir l'entreprise"
              tooltipPlacement="top"
            >
              {item.name_commercial}
            </TableCell>
            <TableCell>
              {item.title}
            </TableCell>
            <TableCell 
              clickable
              onClick={(e) => {
                e.stopPropagation();
                openMissionInfo(item);
              }}
              tooltipText="Voir la mission"
              tooltipPlacement="top"
            >
              {item.id_mission_reel}
            </TableCell>
            <TableCell 
              clickable
              onClick={(e) => {
                e.stopPropagation();
                openTempWorkerInfo(item.id_user);
              }}
              tooltipText="Voir le candidat"
              tooltipPlacement="top"
            >
              {item.firstname} {item.lastname}
            </TableCell>
            <TableCell className={!timeSheetVerified && item.validated === 0 ? '' : ''} position={!timeSheetVerified && item.validated === 0 ? 'last' : 'middle'}>
              {dateWordShort(item.periode_start)} {'>'}{' '}
              {dateWordShort(item.periode_end)}
            </TableCell>
            {timeSheetVerified && (
              <TableCell position={item.validated === 0 ? 'last' : 'middle'}>
                <div className="flex justify-center tr-imported-time-sheet">
                  {waitingStates[item._id] ? (
                    <div className="animate-spin">
                      <Loading2 wh={20} color={'#6B7280'} />
                    </div>
                  ) : (
                    <>
                      {item.is_imported_bestt ? (
                        <div className="flex items-center gap-1 border border-green-200 rounded bg-green-50 text-green-700 py-0.5 px-2">
                          <div>Importé</div>
                          <div
                            className="cursor-pointer tr-button-imported-time-sheet"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleToggleImported(false, item._id);
                            }}
                          >
                            <CrossIcon wh={16} color="#047857" />
                          </div>
                        </div>
                      ) : (
                        <div
                          className="rounded outline-dashed outline-gray-300 w-fit cursor-pointer tr-button-to-import-time-sheet"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleToggleImported(true, item._id);
                          }}
                        >
                          <Plus wh="20" color="#6B7280" />
                        </div>
                      )}
                    </>
                  )}
                </div>
              </TableCell>
            )}
            <TableCell 
              position="last"
              hasButton
              buttonOnClick={(e) => {
                e.stopPropagation();
                if (item.validated === 1 || item.validated === 2) {
                  handleModal(e, item._id, item);
                } else {
                  handleModalConsult(e, item._id, item);
                }
              }}
              buttonContent={item.validated === 1 || item.validated === 2 ? (
                <EyeIcon wh={24} color="#374151" />
              ) : (
                <DocumentIcon wh={24} color="#111827" />
              )}
            />
          </TableRow>
        );
      })}
    </>
  );
};

export default Tbodyhours;
